/* Used to store chart data globally so that it's not overwritten by tab switch */

const actions = {
  updateDragValues(state, data) {
    if (data.dragPosition < 0) {
      //Exclude negative positions which don't work well with width values
      data.dragPosition = 0;
    }
    if (state.state.chartWidth && data.dragPosition > state.state.chartWidth) {
      //Don't allow drag position to exceed right edge of chart
      data.dragPosition = state.state.chartWidth;
    }
    if (data.sliderId === 'slider1') {
      state.state.drag1 = data.dragPosition;
    } else {
      state.state.drag2 = data.dragPosition;
    }
  },
  updateChart(state, data) {
    state.state.updateChart = data;
  },
  setChartWidth(state, data) {
    state.state.chartWidth = data;
    if (state.state.drag2 === null) {
      state.state.drag2 = data;
    }
  },
  setNavLeft(state, data) {
    state.state.navLeft = data;
  }
};

const getters = {
  updateChart: state => state.updateChart,
  drag1: state => state.drag1,
  drag2: state => state.drag2,
  navLeft: state => state.navLeft
};

const state = {};
state.updateChart = {};
state.drag1 = 0;
state.drag2 = null;
state.chartWidth = 0;
state.navLeft = 0;

export default {
  state,
  getters,
  actions
};
